<template>
  <div id="uploadBlock">
    <div v-show="formUploadFieldes.isBeri.isShow">
      <SegmentName class="segmentName--warning">{{ UploadText.is_beri }}</SegmentName>
      <div class="table_block">
        <table>
          <tbody>
            <TableTr v-show="formUploadFieldes.beriTiming.isShow">
              <TableTh>
                {{ formUploadFieldes.beriTiming.name }}
                <RequiredText v-show="formUploadFieldes.beriTiming.required" />
              </TableTh>
              <td>
                <InputRadio
                  :name="formUploadFieldes.beriTiming.key"
                  :choices="beriTimingOptionList"
                  :inputRadioVal.sync="form.beri_timing"
                  :handleChange="($event) => onChangeBeriTiming($event)"
                />
                <!-- <ErrorMessage class="error-beri_timing-required"></ErrorMessage> -->
                <p class="notice" v-if="form.beri_timing === '審査後すぐ'">{{ note.beri_timing_soon }}</p>
              </td>
            </TableTr>
            <TableTr v-show="formUploadFieldes.beriAt.isShow">
              <TableTh>
                {{ formUploadFieldes.beriAt.name }}
                <RequiredText v-show="formUploadFieldes.beriAt.required" />
              </TableTh>
              <td>
                <div>
                  <el-date-picker
                    class="u-w--200"
                    v-model="form.beri_at"
                    type="date"
                    :placeholder="formUploadFieldes.beriAt.placeholder"
                    format="yyyy/M/d"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :id="formUploadFieldes.beriAt.key"
                    :name="formUploadFieldes.beriAt.key"
                    :disabled="!formUploadFieldes.beriAt.required"
                    @change="onChangeBeriDate"
                  >
                  </el-date-picker>
                  <el-select
                    class="u-w--200"
                    v-model="beriTime"
                    :placeholder="formUploadFieldes.beriAt.placeholder"
                    :disabled="!formUploadFieldes.beriAt.required"
                    @change="onChangeBeriTime"
                  >
                    <el-option
                      v-for="item in beriTimeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <p class="notice u-mt--10" v-html="note.beri_timing_specify"></p>
                <ErrorMessage class="error-beri_at-required_if"></ErrorMessage>
                <ErrorMessage class="error-beri_at-date"></ErrorMessage>
              </td>
            </TableTr>
          </tbody>
        </table>
      </div>
    </div>
    <SegmentName>{{ UploadText.direct_debit }}</SegmentName>
    <div class="table_block">
      <table>
        <tbody>
          <TableTr v-show="formUploadFieldes.bankAccountHolder.isShow">
            <TableTh>
              {{ formUploadFieldes.bankAccountHolder.name }}
              <RequiredText v-show="formUploadFieldes.bankAccountHolder.required" />
            </TableTh>
            <td>
              <InputRadio
                :name="formUploadFieldes.bankAccountHolder.key"
                :choices="formUploadFieldes.bankAccountHolder.choices"
                :inputRadioVal.sync="form.bank_account_holder"
                :handleChange="($event) => onChangeBankAccountHolder($event)"
              />
              <ErrorMessage class="error-bank_account_holder-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUploadFieldes.bankAccountHolderName.isShow">
            <TableTh>
              {{ formUploadFieldes.bankAccountHolderName.name }}
              <RequiredText v-show="formUploadFieldes.bankAccountHolderName.required" />
            </TableTh>
            <td>
              <el-input
                class="u-w--200"
                placeholder=""
                :name="formUploadFieldes.bankAccountHolderName.key"
                v-model="form.bank_account_holder_name"
              />
              <ErrorMessage class="error-bank_account_holder_name-required"></ErrorMessage>
              <ErrorMessage class="error-bank_account_holder_name-string"></ErrorMessage>
              <ErrorMessage class="error-bank_account_holder_name-kana_with_space"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUploadFieldes.bankAccountRegistration.isShow">
            <TableTh>
              {{ formUploadFieldes.bankAccountRegistration.name }}
              <RequiredText v-show="formUploadFieldes.bankAccountRegistration.required" />
            </TableTh>
            <td>
              <ul class="bank-account__reg_list">
                <li>
                  <div><el-radio label="A" key="" v-model="bank_account_registration_a" @change="onChangeBankAccountRegistrationA">端末キャッシュカード登録(Anywhere Next)</el-radio></div>
                  <div v-if="bank_account_registration_a === 'A' || form.bank_account_registration === 'A済' || form.bank_account_registration === 'A予定'">
                    <ul>
                      <li><el-radio label="A予定" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">登録予定(A予定)</el-radio></li>
                      <li>
                        <el-radio label="A済" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">登録済(A済)</el-radio>
                          <div>
                            <el-date-picker
                              v-if="formUploadFieldes.bankAccountRegistrationDate.isShow"
                              class="u-w--200"
                              v-model="form.bank_account_registration_date"
                              type="date"
                              :placeholder="formUploadFieldes.bankAccountRegistrationDate.placeholder"
                              format="yyyy/M/d"
                              value-format="yyyy-MM-dd"
                              :id="formUploadFieldes.bankAccountRegistrationDate.key"
                              :disabled="!formUploadFieldes.bankAccountRegistrationDate.required"
                            >
                            </el-date-picker>
                            <p class="notice" v-if="formUploadFieldes.bankAccountRegistrationDate.isShow">
                              {{ note.bank_account_registration_date }}
                            </p>
                            <ErrorMessage v-if="form.bank_account_registration_date === ''" class="error-bank_account_registration_date-required_if"></ErrorMessage>
                            <ErrorMessage class="error-bank_account_registration_date-date"></ErrorMessage>
                          </div>
                      </li>
                    </ul>
                    <ErrorMessage v-if="isInputBankAccountRegistration">どちらか必ず選択してください。</ErrorMessage>
                  </div>
                </li>
                <li v-if="getOption.use_aplus === true">
                  <div><el-radio label="Web登録予定" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">Web登録予定</el-radio></div>
                  <p class="notice">※申込送信後に、お客様マイページよりご登録ください。</p>
                  <p class="notice">マイページはSMSで届くURLよりログインいただくか、当社ホームページ掲載のQRコードを読み取ることでもログイン可能です。</p>
                  <p class="notice">※SMS認証で、認証コードが届かなかったお客様はご利用できません。</p>
                </li>
                <li>
                  <div><el-radio label="口座振替依頼書" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">口座振替依頼書（郵送）</el-radio></div>
                  <p class="notice">※口座振替依頼書はTopページ「各種書類」より印刷いただきご利用ください。（白黒可）</p>
                </li>
              </ul>
              <ErrorMessage v-if="isInputBankAccountRegistration" class="error-bank_account_registration-required">{{BankAccountRegistrationErrorMessage}}</ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>

    <SegmentName>{{ UploadText.identification }}</SegmentName>
    <div class="table_block" id="identification_field">
      <div class="clearfix camera">
        <div v-for="(item, index) in form.identification" :key="index" class="camera__item float-left">
          <div class="camera__item--inner modal__img" @click="item.see = true" :class="{delete: item.delete}">
            <img :src="item.image" alt />
            <i class="el-icon-zoom-in"></i>
          </div>

          <el-dialog title="Upload Image" :visible.sync="item.see" width="80%">
            <div class="uploadImageWrapper">
              <img :src="item.image" alt width="100%" />
              <div class="text-center" style="margin-top: 15px" v-if="item.can_delete">
                <el-button
                  type="danger"
                  @click="
                    item.see = false
                    imageDelete('identification', item.id)
                  "
                >
                  <i class="el-icon-delete"></i> 画像を削除する
                </el-button>
              </div>
            </div>
          </el-dialog>
        </div>
        <div class="camera__item camera__item--add float-left" @click="activeCamera('identification')">
          <div class="camera__item--inner">
            <i class="el-icon-camera camera__icon"></i>
            <p class="camera__txt">写真を追加する</p>
          </div>
        </div>
      </div>
      <!-- <p class="text-danger text-center" v-if="identification_error">画像がアップロード出来ませんでした。再度アップお願いします。</p> -->
      <p class="notice">{{ note.identification[0] }}</p>
      <p class="notice">{{ note.identification[1] }}</p>
      <ErrorMessage class="error-identification-required"></ErrorMessage>
      <ErrorMessage class="error-identification-array"></ErrorMessage>
      <ErrorMessage
        v-for="(item, index) in form.identification"
        :class="[`error-identification.${index}.id-exists`]"
        :key="index"
      ></ErrorMessage>
    </div>

    <SegmentName>{{ UploadText.contract_documents }}</SegmentName>
    <div class="table_block" id="contract_documents_field">
      <div class="clearfix camera">
        <div v-for="(item, index) in form.contract_documents" :key="index" class="camera__item float-left">
          <div class="camera__item--inner modal__img" @click="item.see = true" :class="{delete: item.delete}">
            <img :src="item.image" alt />
            <i class="el-icon-zoom-in"></i>
          </div>

          <el-dialog title="Upload Image" :visible.sync="item.see" width="80%">
            <div class="uploadImageWrapper">
              <img :src="item.image" alt width="100%" />
              <div class="text-center" style="margin-top: 15px" v-if="item.can_delete">
                <el-button
                  type="danger"
                  @click="
                    item.see = false
                    imageDelete('contract_documents', item.id)
                  "
                >
                  <i class="el-icon-delete"></i> 画像を削除する
                </el-button>
              </div>
            </div>
          </el-dialog>
        </div>
        <div class="camera__item camera__item--add float-left" @click="activeCamera('contract_documents')">
          <div class="camera__item--inner">
            <i class="el-icon-camera camera__icon"></i>
            <p class="camera__txt">写真を追加する</p>
          </div>
        </div>
      </div>
      <p class="notice">{{ note.contract_documents }}</p>
      <ErrorMessage class="error-contract_documents-required"></ErrorMessage>
      <ErrorMessage class="error-contract_documents-array"></ErrorMessage>
      <ErrorMessage
        v-for="(item, index) in form.contract_documents"
        :class="[`error-contract_documents.${index}.id-exists`]"
        :key="index"
      ></ErrorMessage>
    </div>

    <SegmentName v-show="getHasMinors">{{ UploadText.parental_consent }}</SegmentName>
    <div v-show="getHasMinors" class="table_block" id="parental_consent_field">
      <div class="clearfix camera">
        <div v-for="(item, index) in form.parental_consent" :key="index" class="camera__item float-left">
          <div class="camera__item--inner modal__img" @click="item.see = true" :class="{delete: item.delete}">
            <img :src="item.image" alt />
            <i class="el-icon-zoom-in"></i>
          </div>

          <el-dialog title="Upload Image" :visible.sync="item.see" width="80%">
            <div class="uploadImageWrapper">
              <img :src="item.image" alt width="100%" />
              <div class="text-center" style="margin-top: 15px" v-if="item.can_delete">
                <el-button
                  type="danger"
                  @click="
                    item.see = false
                    imageDelete('parental_consent', item.id)
                  "
                >
                  <i class="el-icon-delete"></i> 画像を削除する
                </el-button>
              </div>
            </div>
          </el-dialog>
        </div>
        <div class="camera__item camera__item--add float-left" @click="activeCamera('parental_consent')">
          <div class="camera__item--inner">
            <i class="el-icon-camera camera__icon"></i>
            <p class="camera__txt">写真を追加する</p>
          </div>
        </div>
      </div>
      <p class="notice">{{ note.parental_consent }}</p>
      <ErrorMessage class="error-parental_consent-required"></ErrorMessage>
      <ErrorMessage class="error-parental_consent-array"></ErrorMessage>
      <ErrorMessage
        v-for="(item, index) in form.parental_consent"
        :class="[`error-parental_consent.${index}.id-exists`]"
        :key="index"
      ></ErrorMessage>
    </div>

    <input
      type="file"
      name="upfile"
      id="identification"
      accept="image/*"
      capture="camera"
      style="display: none"
      @change="uploadImage"
    />
    <input
      type="file"
      name="upfile"
      id="contract_documents"
      accept="image/*"
      capture="camera"
      style="display: none"
      @change="uploadImage"
    />
    <input
      type="file"
      name="upfile"
      id="parental_consent"
      accept="image/*"
      capture="camera"
      style="display: none"
      @change="uploadImage"
    />

    <div class="next">
      <el-button type="primary" icon="el-icon-arrow-left" @click="backPage">前へ戻る</el-button>
      <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage">決定</el-button>
    </div>

    <el-dialog class="el-receiptDialog" title="受領方法の選択" :visible.sync="checkUser" width="80%">
      <div>
        <p class="el-receiptDialog__mainTitle">お申し込み控えの受領方法をどちらか選択してください。</p>
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <el-button
              class="el-receiptDialog__strongBtn"
              type="primary"
              :disabled="form.is_beri"
              @click="throwNextPage('qr')"
            >
              <p class="el-receiptDialog__btnText">電磁的方法（PDFファイル）による受領（保存）に同意します。</p>
              <p class="el-receiptDialog__btnStrongText">申込を送信する</p>
              <p class="el-receiptDialog__btnText">QRコード表示画面へ</p>
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button class="el-receiptDialog__strongBtn" type="primary" @click="throwNextPage('paper')">
              <p class="el-receiptDialog__btnText">書面による受領を希望します。</p>
              <p class="el-receiptDialog__btnStrongText">申込を送信する</p>
              <p class="el-receiptDialog__btnText">お客様控え発行へ</p>
            </el-button>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkUser = false">戻る</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {mapGetters, mapActions} from 'vuex'
import {helperSmoothScroll} from '@/js/util/helper'
import {uploadFile} from '@/js/util/uploadFile'
import {UploadText} from '@/js/util/constants'
import {FormUploadFieldes} from '@/js/util/member/formUploadFieldes'
import {validate, setErrorLaravel} from '@/js/util/validate/validateFunction'
import {ValidationRules, ValidationMaxSheets} from '@/js/util/member/formUploadValidationRules'
import {Note} from '@/js/util/member/formUploadOptionConstants'
import RequiredText from '@/js/components/member/common/Atoms/RequiredText'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import InputRadio from '@/js/components/member/common/Molecules/InputRadio'
export default {
  data() {
    return {
      checkUser: false,
      upload_type: '',
      identification_error: false,
      contract_documents_error: false,
      parental_consent_error: false,
      formUploadFieldes: {}, // 口座系のみのフィールド
      UploadText: UploadText, // 項目名
      validations: ValidationRules, // バリデーションルール
      note: Note, // 各項目の注意事項
      form: {},
      isHolidayBeriAt: false,
      bank_account_registration_a: '',
      isInputBankAccountRegistration: true, // 口座登録エラー表示フラグ
      BankAccountRegistrationErrorMessage: '口座登録は必ず入力してください。'
    }
  },
  components: {
    ErrorMessage,
    RequiredText,
    SegmentName,
    TableTh,
    TableTr,
    InputRadio
  },
  created() {
    this.form = this.getUploadInputForm
    this.bank_account_registration_a = (this.form.bank_account_registration === 'A済' || this.form.bank_account_registration === 'A予定') ? 'A':''

    this.formUploadFieldes = FormUploadFieldes(this.getHasPayment, this.form, this.getHasRegistration)
    const {userInput} = this.$store.state
    if('contract_documents' in userInput.form) {
      this.form.contract_documents = userInput.form.contract_documents
    }

  },
  mounted() {
    // バリデーションを定義
    validate(this.validations, true, this.hasPayment, false)
    this.$emit('page', 'form-upload')
    window.scrollTo(0, 0)
    // Laravelのバリデーションエラーメッセージ
    if (this.getValidations.length) {
      this.getValidations.map((validate) => {
        setErrorLaravel(validate.key, validate.rule, validate.message, false)
      })
    }
  },
  beforeDestroy() {
    // バリデーションを削除
    if (this.getHasRegistration === 'new') validate(this.validations, true, this.hasPayment, false)
  },
  watch: {
    form: {
      async handler(newValue) {
        this.formUploadFieldes = FormUploadFieldes(this.getHasPayment, newValue, this.getHasRegistration)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      getHasRegistration: 'status/getHasRegistration',
      getOriginalContractId: 'status/getOriginalContractId',
      getLocalCustomerId: 'status/getLocalCustomerId',
      getHasPayment: 'status/getHasPayment',
      getHasMinors: 'status/getHasMinors',
      getRefuseFlag: 'status/getRefuseFlag',
      getUploadInputForm: 'uploads/getForm',
      getValidations: 'uploads/getValidations',
      getId: 'customer/getId',
      getOption: 'productInput/getOption',
    }),
    beriTime: {
      get() {
        if (!this.form.beri_at) {
          return '09:00'
        }

        return moment(this.form.beri_at).format('HH:mm')
      },
      set(value) {
        const time = value ?? '09:00'
        const beriAt = this.form.beri_at ? moment(this.form.beri_at) : moment()
        this.form.beri_at = beriAt.format(`YYYY-MM-DD ${time}:00`)
      }
    },
    beriTimeOptions() {
      return this.isHolidayBeriAt
        ? this.formUploadFieldes.beriAt.beriAtHolidays
        : this.formUploadFieldes.beriAt.beriAtBusinessDays
    },
    /**
     * 本人確認電話欄の確認日時項目に表示する一覧を生成
     */
    beriTimingOptionList() {
      return this.formUploadFieldes.beriTiming.choices.filter(x => x.value !== '完了済')
    }
  },
  methods: {
    nextPage() {
      for (let key in this.validations) {
        this.validations[key].map(async (validation) => {
          await this.ignitionEvent(validation.event, key)
        })
      }
      // 口座登録バリデーション NOTE: 既存のバリデーション機構を利用しない
      this.isInputBankAccountRegistration = false
      if(!this.form.bank_account_registration){
        this.isInputBankAccountRegistration = true
        this.BankAccountRegistrationErrorMessage = '口座登録は必ず入力してください。'
      }
      setTimeout(() => {
        const errors = document.querySelectorAll('.error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helperSmoothScroll(error_class)
        } else {
          this.checkUser = true
        }
      }, 100)
    },
    throwNextPage(mode) {
      // 本人確認電話の場合QRコード表示不可
      if (this.form.is_beri && mode === 'qr') {
        this.$alert('本人確認電話を選択した場合、電磁的方法（PDFファイル）による受領は不可です', '', {
          confirmButtonText: 'OK',
          center: true
        })
        return
      }
      //データベースに保存する処理
      const test = false
      let loading = null
      if (!test) {
        loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }

      this.checkUser = false

      this.$store.commit('uploads/put', this.form)

      // ユーザー入力内容取得 送信データを整える
      const {productInput, userInput, sign, uploads} = this.$store.state // TODO: getterに変える？
      const sendData = {
        step1: {
          ...productInput.form,
          payment_period_start: moment(productInput.form.payment_period_start).format('YYYY-MM-DD HH:mm:ss'),
          payment_period_end: moment(productInput.form.payment_period_end).format('YYYY-MM-DD HH:mm:ss')
        },
        step4: userInput.form,
        step5: {
          ...sign.data
        },
        step6: {
          ...uploads.form
        },
        has_payment: this.getHasPayment,
        type: this.getHasRegistration.toUpperCase(), // DBでは全角のENUMなので変換
        original_contract_id: this.getOriginalContractId,
        customer_user_id: this.getId, // ユーザーID
        local_customer_id: this.getLocalCustomerId, // TFIC顧客ID
        refuse_flag: this.getRefuseFlag
      }
      axios
        .post('/api/store/create/regist', sendData)
        .then((res) => {
          if (!test) {
            loading.close()
            if (res.data[1].id) this.updateHasContractId(res.data[1].id)
            this.$emit('next', mode)
          }
        })
        .catch((err) => {
          loading.close()
          if (err.response.status === 500) {
            this.$alert('送信に失敗しました。お手数ですが、もう一度最初からやり直してください', '不明なエラー', {
              confirmButtonText: 'はい',
              callback: () => {
                this.transitionSame('top')
              }
            })
          }
          // バリデーションが返ってきたら各ページにわけ遷移する。
          if (err.response.data) {
            const errors = {
              step1: [],
              step4: [],
              step5: [],
              step6: []
            }
            const sortingStep = (step, key, val) => {
              val.map((validate) => {
                let terms = validate.split(':')
                const obj = {
                  rule: terms[0],
                  message: terms[1],
                  key: key.replace(`${step}.`, '')
                }
                errors[step].push(obj)
              })
            }
            for (let key in err.response.data) {
              if (key.match('step1')) {
                sortingStep('step1', key, err.response.data[key])
              } else if (key.match('step4')) {
                sortingStep('step4', key, err.response.data[key])
              } else if (key.match('step5')) {
                sortingStep('step5', key, err.response.data[key])
              } else if (key.match('step6')) {
                sortingStep('step6', key, err.response.data[key])
              } else {
                this.$alert('送信に失敗しました。お手数ですが、もう一度最初からやり直してください', '不明なエラー', {
                  confirmButtonText: 'はい',
                  callback: () => {
                    this.transitionSame('top')
                  }
                })
                return false
              }
            }
            this.updateValidationsProductInput(errors.step1)
            this.updateValidationsUserInput(errors.step4)
            this.updateValidationsSigin(errors.step5)
            this.updateValidationsUpload(errors.step6)
            if (errors.step1.length) {
              this.$emit('transition', 'form-product-input')
            } else if (errors.step4.length) {
              this.$emit('transition', 'form-user-input')
            } else if (errors.step5.length) {
              this.$emit('transition', 'form-sigin')
            } else if (errors.step6.length) {
              // Laravelのバリデーションエラーメッセージ
              if (this.getValidations.length) {
                this.getValidations.map((validate) => {
                  setErrorLaravel(validate.key, validate.rule, validate.message, false)
                })

                // 口座登録バリデーション NOTE: 既存のバリデーション機構を利用しない
                if(errors.step6[0].key === 'bank_account_registration')
                this.$alert('口座登録に不備がございます。', '', {
                  confirmButtonText: 'OK',
                  center: true
                })

              }
            }
          }
        })
    },
    backPage() {
      this.$emit('back')
    },
    activeCamera(type) {
      //カメラを起動する処理
      this.upload_type = type
      if (ValidationMaxSheets[type] > this.form[type].length) {
        document.getElementById(this.upload_type).click()
      }
    },
    uploadImage() {
      //画像を保存する処理
      let element = document.getElementById(this.upload_type)
      if (element.files[0]) {
        const uploadType = this.upload_type

        const loading = this.$loading({
          target: '#' + uploadType + '_field',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          text: 'アップロード中',
          customClass: 'uploadImageLoading'
        })

        // エラーを消す
        this.identification_error = this.contract_documents_error = this.parental_consent_error = false

        setTimeout(() => {
          uploadFile('/upload', element.files[0])
            .then((response) => {
              const data = response.data
              const imageData = {
                image: data.base64.encoded,
                id: data.image.id,
                can_delete: true,
                delete: false,
                see: false
              }
              if (uploadType == 'identification') {
                this.form.identification.push(imageData)
              }
              if (uploadType == 'contract_documents') {
                this.form.contract_documents.push(imageData)
              }
              if (uploadType == 'parental_consent') {
                this.form.parental_consent.push(imageData)
              }

              loading.close()
            })
            .catch((error) => {
              if (uploadType == 'identification') {
                this.identification_error = true
              }
              if (uploadType == 'contract_documents') {
                this.contract_documents_error = true
              }
              if (uploadType == 'parental_consent') {
                this.parental_consent_error = true
              }
              loading.close()
            })
        }, 20)
      }
    },

    imageDelete(type, id) {
      //画像を削除する処理
      let imageObjects
      if (type == 'identification') {
        imageObjects = this.form.identification
      }
      if (type == 'contract_documents') {
        imageObjects = this.form.contract_documents
      }
      if (type == 'parental_consent') {
        imageObjects = this.form.parental_consent
      }
      imageObjects.some(function (v, i) {
        if (v.id == id) imageObjects.splice(i, 1) //id:3の要素を削除
      })
    },

    /**
     * 口座名義人に変更があったとき
     */
    onChangeBankAccountHolder(e) {
      this.setBankAccountHolderName(e)
      this.ignitionEvent('blur', 'bank_account_holder_name')
    },

    /**
     * 口座登録に変更があったとき
     */
    onChangeBankAccountRegistration(e) {
      this.ignitionEvent('blur', 'bank_account_registration')
      this.isInputBankAccountRegistration = false
      this.BankAccountRegistrationErrorMessage = ''
      this.form.bank_account_registration_date = ''
      if (e === 'A済') {
        this.form.bank_account_registration_date = moment().format('YYYY-MM-DD')
      }else if(e === 'Web登録予定' || e === '口座振替依頼書') {
        this.bank_account_registration_a = ''
      }
    },

    onChangeBankAccountRegistrationA(e) {
      this.ignitionEvent('blur', 'bank_account_registration')
      this.isInputBankAccountRegistration = true
      this.BankAccountRegistrationErrorMessage = '口座登録は必ず入力してください。'
      if(e === 'A') {
        if(this.form.bank_account_registration !== 'A済') {
          this.form.bank_account_registration_date = ''
        }
        if(this.form.bank_account_registration !== 'A済' && this.form.bank_account_registration !== 'A予定') {
          this.form.bank_account_registration = ''
        }
      }
    },

    /**
     * 口座名義人名の自動入力
     */
    setBankAccountHolderName(e) {
      const {userInput} = this.$store.state
      const surnameKana = _.cloneDeep(userInput.form.surname_kana)
      const nameKana = _.cloneDeep(userInput.form.first_name_kana)
      const fullname_kana = surnameKana && nameKana ? `${surnameKana} ${nameKana}` : ''
      if (e === '本人' && fullname_kana) {
        this.form.bank_account_holder_name = fullname_kana
      }
    },

    onChangeBeriTiming(e) {
      this.form.beri_at = null
      this.ignitionEvent('blur', 'beri_at')

      if (e === '指定日時選択') {
        this.form.beri_at = moment().format('YYYY-MM-DD 09:00:00')
        this.setBeriAtTimeOption(this.form.beri_at) // ベリ予定時間の選択範囲
      }
    },

    setBeriAtTimeOption(beriAt) {
      const selectedDate = beriAt ? moment(beriAt, 'YYYY-MM-DD HH:mm:ss') : moment()
      const year = selectedDate.year()
      axios
        .get('/api/store/calendar/', {
          params: {year}
        })
        .then((res) => {
          const {data} = res
          if (!data) return
          let isHoliday = selectedDate.get('day') % 6 === 0 //土日
          if (!isHoliday) {
            const holidays = data.calendarDays.concat(data.nationalHolidays)
            isHoliday = holidays.some(
              (item) => moment(item.date).format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD')
            )
          }
          this.isHolidayBeriAt = isHoliday
          this.ignitionEvent('blur', 'beri_at')
        })
        .catch(() => {
          this.$alert('休日情報取得に失敗しました', 'サーバーエラー', {
            confirmButtonText: '閉じる'
          })
        })
    },

    onChangeBeriDate(e) {
      // 予定時刻 年月日変更イベント
      if (e) {
        this.form.beri_at = moment(e).format('YYYY-MM-DD 09:00:00')
        this.setBeriAtTimeOption(this.form.beri_at) // ベリ予定時間の選択範囲
      }
    },

    onChangeBeriTime() {
      this.ignitionEvent('blur', 'beri_at')
    },

    ...mapActions({
      // 登録後の契約IDを更新
      updateHasContractId: 'status/updateHasContractId',
      updateValidationsProductInput: 'productInput/updateValidations',
      updateValidationsUserInput: 'userInput/updateValidations',
      updateValidationsSigin: 'sign/updateValidations',
      updateValidationsUpload: 'uploads/updateValidations'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

#productBlock {
  .product_titles {
    overflow: hidden;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    p {
      float: left;
      margin-bottom: 0;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #666;
    }

    p.product_name {
      width: 50%;
    }
    p.product_amount {
      width: 15%;
    }
    p.product_price {
      width: 25%;
    }
    p.product_delete {
      width: 10%;
    }
  }
  .product_list {
    margin-bottom: 0;
    list-style: none;
    padding-left: 0;
    margin-bottom: 10px;
    li {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .error_message {
        padding: 5px;
        border: 1px solid red;
        margin-top: 8px;
        border-radius: 4px;
      }
    }

    .product_box {
      overflow: hidden;

      .product_name,
      .product_amount,
      .product_price,
      .product_delete {
        float: left;
      }

      .product_name {
        width: 50%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_amount {
        width: 15%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_price {
        width: 25%;
        padding-right: 10px;
        .el-input {
          width: 100%;
        }
      }

      .product_delete {
        width: 10%;
        text-align: center;
      }
    }
  }

  .payment_form {
    margin-top: 10px;
  }

  .payment_style_title {
    font-size: 12px;
    font-weight: bold;
    color: $--color-primary;
    text-align: center;
  }
}

.bank-account__reg_list {
  list-style:none;
  padding-inline-start:0;
  ul {
    list-style:none;
    padding-inline-start:23px;
    li {
      div {
        margin-left: 12px;
      }
      p {
        &.notice {
          white-space:nowrap;
          margin-left: 12px;
        }
        &.error_message {
          margin-left: 12px;
        }
      }
    }
  }


  & > li {
    margin-bottom:18px;

    .bank-account__reg_list__a_list {
      li {
        margin-bottom:6px;
      }
    }
    p {
      &.notice {
        white-space:nowrap;
        margin-left: 24px;
      }
      &.error_message {
        //margin-left: 24px;
      }
    }
  }
}

.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}
.camera {
  padding-top: 40px;

  .delete {
    opacity: 0.3;
  }

  &__item {
    width: 28%;
    height: 25vw;
    margin-bottom: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    padding: 5px;
    &:nth-child(3n + 1) {
      margin-left: 4%;
    }
    &:nth-child(3n - 1) {
      margin-left: 4%;
      margin-right: 4%;
    }
    &--inner {
      border: 1px solid #d3d3d3;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 5px;
      & img {
        max-width: 90%;
        max-height: 21vw; // 規定の高さを入れる（可変）
        height: auto;
        vertical-align: bottom;
      }
    }
    &--add {
      border: 1px solid $--color-primary;
      & .camera__item--inner {
        background-color: #f8f8f8;
      }
    }
  }
  &__icon {
    font-size: 6vw;
  }
  &__txt {
    font-size: 2.5vw;
    margin: 0;
  }
}
.checkbox_area {
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid #eee;
  padding-top: 15px;
}
.modal {
  &-wrap {
    width: 100%;
    height: 80vh;
    position: relative;
    & img {
      max-width: 100%;
      max-height: 80vh;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__img {
    position: relative;
    & i {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 3vw;
      cursor: pointer;
    }
  }
}
.el-receiptDialog {
  &__mainTitle {
    font-size: 16px;
    font-weight: bold;
  }
  &__btnText {
    font-size: 12px;
    margin-top: 1rem;
    white-space: pre-wrap;
    line-height: 1.5;
  }
  &__btnStrongText {
    font-size: 20px;
  }
  &__strongBtn {
    display: block;
    width: 100%;
    height: 100%;
  }
  .el-row--flex {
    align-items: stretch;
  }
}
.segmentName--warning {
  background-color: $--color-warning;
}
</style>
